import $ from 'jquery';
import stickybits from 'stickybits';


$(function() {


	/* Mobile nav
	********************************************/

	var backLabel = $('ul.mobile-nav').data('back');

	$('a.menu-toggle').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('open');
		$('html').toggleClass('mobile-navigation-opened');
		$('.mobile-menu-wrapper').toggleClass('show');
	});

	$('ul.mobile-nav li.parent > a').on('click', function(e){
		e.stopImmediatePropagation();
		e.preventDefault();
		var $this = $(this);
		var parentTitle = $this.parent().attr('data-parent');
		var parentIcon = $this.parent().attr('data-icon');
		var $subMenu = $this.siblings('ul.submenu');
		var check_icon = parentIcon.split(" ");
		var no_icon = $.inArray( 'no-icon', check_icon );
		if(!($subMenu).hasClass('generated') && typeof parentTitle !== 'undefined'){
			var hasIcon = '';
			if(typeof parentIcon !== 'undefined'){ var hasIcon = ' has-icon'}
			if(parentTitle){
				if( no_icon == 1 ){
					$this.siblings('ul.submenu').prepend('<li class="back"><a href="#">'+backLabel+'</a></li><li class="title"><span>'+parentTitle+'</span></li>');
				}else{
					$this.siblings('ul.submenu').prepend('<li class="back"><a href="#">'+backLabel+'</a></li><li class="title'+hasIcon+'"><span><i class="'+parentIcon+'"></i>'+parentTitle+'</span></li>');
				}
			}else{
				$this.siblings('ul.submenu').prepend('<li class="back"><a href="#">'+backLabel+'</a></li>');
			}
		}
		$this.siblings('ul.submenu').addClass('show generated');
		$this.closest('ul.submenu').addClass('push-back');
	});

	$('body').on('click', 'li.back > a', function(e){
		e.preventDefault();
		$(this).closest('ul.submenu').removeClass('show');
		$(this).closest('ul.submenu.push-back').removeClass('push-back');
	});


	/* Menu equal height
	********************************************/

	function equalize( selector ) {
		const $parents = $( selector );
		if ( ! $parents.length ) {
			return;
		}
		$parents.each( function () {
			let maxHeight = 0;
			$( this ).children().each( function () {
				if ( $( this ).outerHeight() > maxHeight ) {
					maxHeight = $( this ).outerHeight();
				}
			} );
			$( this ).children().css( 'min-height', maxHeight );
		} );
	};
	equalize( '.has-equal-height-children' );


	/* Search
	********************************************/

	$('ul.main-menu li.search a.search-button').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$('.site-header .main-nav').toggleClass('search-active');
		$('li.search input').trigger('focus');
	});

	$('ul.main-menu li.search a.close-search').on('click', function(e){
		e.preventDefault();
		$(this).siblings('a.search-button').toggleClass('active');
		$('.site-header .main-nav').toggleClass('search-active');
	});


	/* Sticky
	********************************************/

	var logoHeight = $('#site-header .site-title').outerHeight(true);

	if ($(window).width() < 769) {
		stickybits('#site-header', {
			useStickyClasses: true,
			//useFixed: true,
			//stickyBitStickyOffset: - pageHeaderHeight - 20,
			//customStickyChangeNumber: 10
		});
	} else {
		stickybits('#site-header', {
			useStickyClasses: true,
			//useFixed: true,
			stickyBitStickyOffset: - logoHeight - 1,
			//customStickyChangeNumber: 10
		});
	}



});
